import { render } from "./validatable-input.vue?vue&type=template&id=45987fa0"
import script from "./validatable-input.vue?vue&type=script&lang=js"
export * from "./validatable-input.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__